import { apiRequest, clearGetCache } from './api';

function getAuthHeaders() {
  try {
    const token = window.localStorage.getItem('chse_auth_token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
}

export async function getReviews() {
  return apiRequest('/api/reviews');
}

export async function createReview({ courseId, rating, comment }) {
  const body = {
    course_id: Number(courseId),
    rating: Number(rating),
  };

  const trimmedComment = typeof comment === 'string' ? comment.trim() : '';
  if (trimmedComment) {
    body.comment = trimmedComment;
  }

  const response = await apiRequest('/api/reviews', {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(body),
  });

  clearGetCache('/api/reviews');
  clearGetCache(`/api/courses/${courseId}/reviews`);
  return response;
}
